// src/modules/app-views/crm/pages/Kanban/components/modals/ColumnPropertiesModal/tabs/MetricsTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Form } from 'antd';
import translateX from 'utils/translateX';
import SimpleTime from 'components/SimpleComponents/SimpleTime';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const MetricsTab = ({ form }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  // Defined inside component so translateX is called at render time, not module init
  const slaTypes = [
    { value: 'elapsed', label: translateX('sla_elapsed'), tooltip: translateX('sla_elapsed_hint') },
    {
      value: 'business',
      label: translateX('sla_business'),
      tooltip: translateX('sla_business_hint'),
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Form form={form} layout="vertical" className="mt-3">
      <Form.Item
        name="sla"
        label={translateX('sla_attendance')}
        tooltip={translateX('sla_time_hint')}
        style={{ cursor: 'default' }}
      >
        <SimpleTime
          types={slaTypes}
          defaultType="elapsed"
          units={['minutes', 'hours', 'days', 'weeks', 'months']}
          defaultUnit="hours"
        />
      </Form.Item>
    </Form>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default MetricsTab;
